// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/email/v1/recipient_opt_out.proto (package kitecorp.transferify.email.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/email/v1/recipient_opt_out.proto.
 */
export const file_kitecorp_transferify_email_v1_recipient_opt_out: GenFile = /*@__PURE__*/
  fileDesc("CjVraXRlY29ycC90cmFuc2ZlcmlmeS9lbWFpbC92MS9yZWNpcGllbnRfb3B0X291dC5wcm90bxIda2l0ZWNvcnAudHJhbnNmZXJpZnkuZW1haWwudjEiOgofR2V0UmVjaXBpZW50T3B0T3V0U3RhdHVzUmVxdWVzdBIXCgpsaW5rX3Rva2VuGAEgASgJQgOAAQEiTAogR2V0UmVjaXBpZW50T3B0T3V0U3RhdHVzUmVzcG9uc2USEgoFZW1haWwYASABKAlCA4ABARIUCgx1bnN1YnNjcmliZWQYAiABKAgyvAEKFlJlY2lwaWVudE9wdE91dFNlcnZpY2USoQEKGEdldFJlY2lwaWVudE9wdE91dFN0YXR1cxI+LmtpdGVjb3JwLnRyYW5zZmVyaWZ5LmVtYWlsLnYxLkdldFJlY2lwaWVudE9wdE91dFN0YXR1c1JlcXVlc3QaPy5raXRlY29ycC50cmFuc2ZlcmlmeS5lbWFpbC52MS5HZXRSZWNpcGllbnRPcHRPdXRTdGF0dXNSZXNwb25zZSIEirUYAEJFCitjb20ua2l0ZWNvcnAuY29udHJhY3RzLnRyYW5zZmVyaWZ5LmVtYWlsLnYxQhRSZWNpcGllbnRPcHRPdXRQcm90b1ABYgZwcm90bzM", [file_kitecorp_options_v1_options]);

/**
 * Names the link whose status is asked.
 *
 * @generated from message kitecorp.transferify.email.v1.GetRecipientOptOutStatusRequest
 */
export type GetRecipientOptOutStatusRequest = Message<"kitecorp.transferify.email.v1.GetRecipientOptOutStatusRequest"> & {
  /**
   * The token of the mailed link. Whoever holds it can opt the address out, so a log hides it.
   *
   * @generated from field: string link_token = 1;
   */
  linkToken: string;
};

/**
 * Describes the message kitecorp.transferify.email.v1.GetRecipientOptOutStatusRequest.
 * Use `create(GetRecipientOptOutStatusRequestSchema)` to create a new message.
 */
export const GetRecipientOptOutStatusRequestSchema: GenMessage<GetRecipientOptOutStatusRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_email_v1_recipient_opt_out, 0);

/**
 * Where the address behind the link stands.
 *
 * @generated from message kitecorp.transferify.email.v1.GetRecipientOptOutStatusResponse
 */
export type GetRecipientOptOutStatusResponse = Message<"kitecorp.transferify.email.v1.GetRecipientOptOutStatusResponse"> & {
  /**
   * The address the link was mailed to. A log hides it.
   *
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * Whether the address has already unsubscribed.
   *
   * @generated from field: bool unsubscribed = 2;
   */
  unsubscribed: boolean;
};

/**
 * Describes the message kitecorp.transferify.email.v1.GetRecipientOptOutStatusResponse.
 * Use `create(GetRecipientOptOutStatusResponseSchema)` to create a new message.
 */
export const GetRecipientOptOutStatusResponseSchema: GenMessage<GetRecipientOptOutStatusResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_email_v1_recipient_opt_out, 1);

/**
 * The page a transfer recipient opens from the unsubscribe link in a mail (kitecorp/contracts#71). Anonymous: the
 * link's token is the credential, and the person opening it has no session.
 *
 * @generated from service kitecorp.transferify.email.v1.RecipientOptOutService
 */
export const RecipientOptOutService: GenService<{
  /**
   * Reads whether the address behind the token has already unsubscribed. The token travels in the body and never in a
   * URL, so the call is left with unknown idempotency and is not sent as a GET.
   *
   * @generated from rpc kitecorp.transferify.email.v1.RecipientOptOutService.GetRecipientOptOutStatus
   */
  getRecipientOptOutStatus: {
    methodKind: "unary";
    input: typeof GetRecipientOptOutStatusRequestSchema;
    output: typeof GetRecipientOptOutStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_email_v1_recipient_opt_out, 0);

